(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Specializzazione', Specializzazione);

    Specializzazione.$inject = ['$resource'];

    function Specializzazione ($resource) {
        var resourceUrl =  'api/specializzaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
